import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import AlertBanner from "../components/generic/AlertBanner";
import { MessageType } from "../constants/Messages";
import { TABS } from "../constants/MainTabs";

interface InventoryManagementPageProps {
    activeTab?: number; // Optional prop to set the initial active tab
}

const InventoryManagementPage: React.FC<InventoryManagementPageProps> = ({ activeTab = 0 }) => {
    const [ activeTabState, setActiveTab ] = useState<number>(activeTab);
    const [ alert, setAlert ] = useState<{ type: MessageType; message: string } | null>(null);

    const navigate = useNavigate();
    const location = useLocation();

    // Set the active tab based on the URL path
    useEffect(() => {
        const path = location.pathname.split("/").pop(); // Get the last part of the URL
        const tabIndex = TABS.findIndex((tab: any) => tab.endpoint === path); // Find tab by endpoint
        if (tabIndex !== -1) {
            setActiveTab(tabIndex);
        }
    }, [ location ]);

    // Handle tab change and update URL
    const handleTabChange = (label: string) => {
        const newActiveTab = TABS.findIndex((tab: any) => tab.label === label);
        if (newActiveTab !== -1) {
            setActiveTab(newActiveTab);
            navigate(`/${TABS[newActiveTab].endpoint}`); // Update URL with normalized endpoint
        }
    };

    return (
        <div>
            {/* Alert Banner */}
            {alert && (
                <AlertBanner
                    message_type={alert.type}
                    message={alert.message}
                    onClose={() => setAlert(null)}
                />
            )}

            {/* Tab Content */}
            <div>
                {TABS[activeTabState]?.component && React.createElement(TABS[activeTabState].component)}
            </div>
        </div>
    );
};

export default InventoryManagementPage;
